import { useEffect } from 'react';
import { useModalContext } from './useModalContext';

export const useModalNameLS = () => {
  const { openedModalName } = useModalContext();

  useEffect(() => {
    if (!openedModalName) {
      localStorage.removeItem('openedModalName');
      return;
    }
    localStorage.setItem('openedModalName', openedModalName);
  }, [openedModalName]);
};
